import styled, { css } from 'styled-components';

import { Tooltip } from '~/components/tooltip/Tooltip';
import { borderRadius } from '~/design-tokens/border-radius/borderRadius';
import { typographyV2 } from '~/design-tokens/typography/Typography.styles';

export const TooltipRoot = styled.div`
  position: absolute;
  top: 40px;
  width: 1px;
  height: 1px;
`;

export const TooltipLabelContainer = styled.div<{ $isMultiAsset?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: ${({ $isMultiAsset }) => ($isMultiAsset ? '259px' : '160px')};
  padding: 12px;
  box-sizing: border-box;
`;

export const DateRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
`;

export const DateLabel = styled.span`
  ${typographyV2.bodyXs}
  color: var(--text-default);
  flex: 1 0 0;
`;

export const DateSubtitle = styled.span`
  ${typographyV2.bodyXs}
  color: var(--text-default);
  flex-shrink: 0;
`;

export const TooltipRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const TooltipLegend = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
`;

export const TooltipLegendColor = styled.div<{
  $color: string;
  $dashed?: boolean;
}>`
  width: 8px;
  height: 8px;
  ${borderRadius.rFull}
  background-color: ${({ $color }) => $color};
  ${({ $dashed, $color }) =>
    $dashed &&
    css`
      width: 12px;
      height: 1px;
      border-bottom: 1.5px dashed ${$color};
      background: none;
      border-radius: unset;
    `}
`;

export const TooltipLabel = styled.span`
  ${typographyV2.bodyXs}
  color: var(--text-default);
`;

export const TooltipValue = styled.span<{ $color?: string }>`
  ${typographyV2.bodyXs}
  font-family: var(--font-roboto-mono);
  text-align: right;
  flex-shrink: 0;
  color: ${({ $color }) => $color ?? 'var(--text-default)'};
`;

export const TooltipValueArea = styled.div`
  text-align: right;
  flex-shrink: 0;
`;

export const ChartTooltip = styled(Tooltip)`
  pointer-events: none;
  padding: 0;
`;
